import mixins from 'vue-typed-mixins';

import { eventBus } from '@/services/event-bus';

import hashService from '../hash-service';

export const interactsHash = mixins().extend({
	data() {
		return {
			lastHash: null as { [index: string]: string } | null
		};
	},
	mounted() {
		this.lastHash = hashService.currentHash() as { [index: string]: string };
		this.hashChanged(this.lastHash, Object.keys(this.lastHash));
		eventBus.$on('hash-changed', this.onHashChange);
	},
	destroyed() {
		eventBus.$off('hash-changed', this.onHashChange);
	},
	methods: {
		onHashChange(hash: { [index: string]: string }): void {
		  const keys = [...new Set(Object.keys(hash).concat(Object.keys(this.lastHash as {})))];
			const changed = keys.filter(key => this.lastHash && this.lastHash[key] !== hash[key]);

			if (!changed.length)
			  return;

			this.hashChanged(hash, changed);
			this.lastHash = hash;
		},
		setHash(obj: { [index: string]: string }, clearOther = false): void {
			hashService.setHash(obj, clearOther);
		},
		getHash(fields: string[] | null = null): { [index: string]: string } {
			if (!fields)
				return hashService.currentHash();

			const result: { [index: string]: string } = {};
			fields.forEach(field => {
				const value = hashService.currentHash()[field];
				if (value)
					result[field] = value;
			});
			return result;
		},
		// Abstract method
		hashChanged(data: object, changed: string[]): void {
		}
	},
});
